import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDepartments } from '../../../../interface/interfaces';
import { departmentInitialState } from '../../../../initials/initials';

interface IInitialState {
    currentSourceDepartment: IDepartments;
    currentTargetDepartment: IDepartments;
}

const initialState: IInitialState = {
    currentSourceDepartment: departmentInitialState,
    currentTargetDepartment: departmentInitialState,
};

const sourceTargetDepartmentSlice = createSlice({
    name: 'sourceTargetDepartment',
    initialState,
    reducers: {
        addSourceTargetDepartment: (state: IInitialState, action: PayloadAction<{ source: IDepartments; target: IDepartments }>) => {
            state.currentSourceDepartment = action.payload.source;
            state.currentTargetDepartment = action.payload.target;
        },
        cleanSourceTargetDepartment: (state: IInitialState) => {
            state.currentSourceDepartment = departmentInitialState;
            state.currentTargetDepartment = departmentInitialState;
        },
    },
});

export default sourceTargetDepartmentSlice.reducer;
export const { addSourceTargetDepartment, cleanSourceTargetDepartment } = sourceTargetDepartmentSlice.actions;
